'use client';

import Script from 'next/script';
import { usePathname } from 'next/navigation';
import { useConsentRuntime } from 'components/shared/consent/ConsentRuntime';
import { TRACKERS } from 'lib/analytics/trackers';
import { trackersLive } from 'lib/analytics/destinations';
import { isPerformanceLabRoute } from './performanceLabNavRoutes';

const GOOGLE_ADS_ID = TRACKERS.googleAds.id;
const PHONE_CONVERSION_ID = `${GOOGLE_ADS_ID}/obrZCPvL1MQcEPj4maUC`;
const PHONE_CONVERSION_NUMBER = '+918047282422';

/**
 * Google Ads phone-conversion tag for Performance Lab pages.
 * The site-wide Ads tag loads from the tracker table after consent.
 */
export const PerformanceLabGoogleAdsHead = () => {
  const pathname = usePathname();
  const { granted } = useConsentRuntime();

  if (!isPerformanceLabRoute(pathname)) {
    return null;
  }
  // Live tag ids only on production, like every other tracker.
  if (!granted.ads || !trackersLive()) {
    return null;
  }

  return (
    <>
      <Script
        strategy="afterInteractive"
        src={`https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ADS_ID}`}
      />
      <Script
        id="performance-lab-google-ads-config"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${GOOGLE_ADS_ID}');
          `,
        }}
      />
      <Script
        id="performance-lab-google-ads-phone-conversion"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            gtag('config', '${PHONE_CONVERSION_ID}', {
              'phone_conversion_number': '${PHONE_CONVERSION_NUMBER}'
            });
          `,
        }}
      />
    </>
  );
};
